export default function getActionResultDesc(dataMsg) {
  return {
    description: `
${'```ts'}
{
  data?: object,     //${dataMsg || '返回的数据'}
  success: boolean, //是否调用成功
  message?: string,  //报错信息
}  
${'```'}
    `
  };
}
export const resSchema = getActionResultDesc('接口返回的数据');
//# sourceMappingURL=getResultDesc.js.map
